module.exports = __webpack_public_path__ + "img/video-lamp.b30a3aa7.png";